// extracted by mini-css-extract-plugin
module.exports = {"empty":"_2ys8Ai8O self-center","label":"EJQ3Sp82","sub-label":"_10erfbgp","subLabel":"_10erfbgp","icon":"_2llaQlfx block mx-auto"};